const newCustomer = {
  snackbar: "Su actualización esta completada",
  name: "Clasificación de área peligrosa",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Clasificación de área peligrosa",
  formTitle: "Clasificación de área peligrosa",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar"
};
export default newCustomer;
